<template>
  <div class="clubFAQ">
    <h2>Частые вопросы</h2>
    <SpoiledText
      v-for="faq in faqItems"
      :key="faq.id"
      :header="faq.description"
      :text="faq.content"
    ></SpoiledText>
  </div>
</template>

<script>
import SpoiledText from "@/components/ui/SpoiledText.vue";
import {onMounted, ref} from "vue";
import {useCustomPagesStore} from "@/store/custom-pages";

export default {
  name: "ClubFAQ",
  components: {SpoiledText},
  setup() {
    const faqItems = ref([])
    const customPagesStore = useCustomPagesStore()

    onMounted(async () => {
      await customPagesStore.loadClubFaq()
      faqItems.value = customPagesStore.items
    })

    return {faqItems}
  }
}
</script>


<style scoped lang="scss">
.clubFAQ {
  text-align: left;

  h2 {
    font-family: var(--cd-bold-font);
    font-size: clamp(24px, 4vw, 36px);
    font-weight: 500;
  }

  :deep(.spoiledText__header) {
    font-weight: 700;
  }
}
</style>
